import styled from 'styled-components';

import { blackSphera, whiteSphera } from 'src/utilities/UIStyles/variables/Colors';

export const FooterContainer = styled.footer`
  background-color: ${blackSphera};
  color: ${whiteSphera};
  padding: 0 5%;
  padding-bottom: 2.5%;

  > h2 {
    font-size: 1.2vw;
    font-weight: bold;
    padding-top: 2%;
    padding-bottom: 1%;
  }

  > p:nth-child(2) {
    font-size: 1.2vw;
    text-align: justify;
    line-height: 25px;
    width: 95%;
    margin-bottom: 2.5%;

    > a {
      color: ${whiteSphera};
      text-decoration: none;
      font-weight: 900;
    }

    > span {
      font-weight: bold;
    }
  }

  > p:nth-child(3) {
    font-size: 1.2vw;
    text-align: justify;
    line-height: 25px;
    width: 95%;

    > a {
      color: ${whiteSphera};
      text-decoration: none;
      font-weight: bold;
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    padding-bottom: 1%;

    > h2 {
      font-size: 1.3vw;
    }

    > p:nth-child(2) {
      font-size: 1.3vw;

      > a {
      }

      > span {
      }
    }

    > p:nth-child(3) {
      font-size: 1.3vw;
      > a {
      }
    }
  }

  @media (max-width: 600px) {
    > h2 {
      font-size: 5vw;
      padding-top: 5%;
      padding-bottom: 3%;
    }

    > p:nth-child(2) {
      font-size: 4vw;

      > a {
      }

      > span {
      }
    }

    > p:nth-child(3) {
      font-size: 4vw;

      > a {
      }
    }
  }
`;

export const LastPartFooter = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 10%;

  > h3 {
    font-size: 1.2vw;
    font-weight: bold;
    width: 100%;
  }

  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
    > h3 {
      font-size: 4.2vw;
    }
  }
`;

export const MediaCont = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 60%;
  margin-right: 23%;

  > figure {
    width: 45px;
    height: 45px;
    margin-right: 2%;

    > a {
      > img {
        width: 100%;
        height: auto;
      }
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 40%;
    margin-right: 35%;

    > figure {
      margin-right: 5%;

      > a {
        > img {
        }
      }
    }
  }
`;

export const LogoCont = styled.figure`
  width: 12%;

  > img {
    width: 100%;
    height: auto;
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > img {
    }
  }

  @media (max-width: 600px) {
    width: 25%;

    > img {
    }
  }
`;
